if (!customElements.get('faq-tabs')) {
  customElements.define('faq-tabs', class FaqTabs extends HTMLElement {
    connectedCallback() {
      // Move nav pills from content area into the nav list
      const navList = this.querySelector('.faq-tabs__nav-list');
      this.querySelectorAll('[data-tab-nav]').forEach(pill => navList.appendChild(pill));

      this.navItems = [...this.querySelectorAll('.faq-tabs__nav-item')];
      this.panels   = [...this.querySelectorAll('[data-tab-panel]')];

      // Activate the first tab by default
      if (this.navItems.length) this.#activateTab(this.navItems[0]);

      this.navItems.forEach(navItem => {
        navItem.addEventListener('click', () => this.#activateTab(navItem));
        navItem.addEventListener('keydown', e => this.#onKeydown(e, navItem));
      });
    }

    #activateTab(navItem) {
      this.navItems.forEach(item => {
        item.classList.remove('current');
        item.setAttribute('aria-selected', 'false');
        item.setAttribute('tabindex', '-1');
      });

      navItem.classList.add('current');
      navItem.setAttribute('aria-selected', 'true');
      navItem.setAttribute('tabindex', '0');

      this.#activatePanel(navItem.dataset.tab);
    }

    #activatePanel(tabId) {
      this.panels.forEach(panel => panel.classList.remove('current'));
      this.querySelector(`[data-tab-panel="${tabId}"]`)?.classList.add('current');
    }

    #onKeydown(e, navItem) {
      const idx = this.navItems.indexOf(navItem);
      const { length } = this.navItems;

      const keyMap = {
        ArrowRight: (idx + 1) % length,
        ArrowDown:  (idx + 1) % length,
        ArrowLeft:  (idx - 1 + length) % length,
        ArrowUp:    (idx - 1 + length) % length,
      };

      if (e.key in keyMap) {
        e.preventDefault();
        const target = this.navItems[keyMap[e.key]];
        this.#activateTab(target);
        target.focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.#activateTab(navItem);
      }
    }
  });
}
